import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=48671b57&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=48671b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48671b57",
  null
  
)

export default component.exports